import { Separator, Skeleton } from '@massilia/ui'

export function AssurancesLoadingSkeleton() {
  return (
    <div className="flex w-full flex-col gap-8 px-4 py-8 md:px-28 lg:flex-row lg:gap-12">
      {/* Left column */}
      <div className="flex flex-1 flex-col gap-9">
        {/* Trip header */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-64" />
          <Skeleton className="h-8 w-96" />
        </div>

        {/* Title + description */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-6 w-72" />
          <Skeleton className="h-4 w-full max-w-xl" />
        </div>

        {/* Radio options */}
        <div className="flex flex-col gap-0">
          <Skeleton className="h-20 w-full rounded-t-2xl" />
          <Skeleton className="h-20 w-full rounded-b-2xl" />
        </div>

        {/* Navigation buttons */}
        <div className="flex justify-between">
          <Skeleton className="h-10 w-40" />
          <Skeleton className="h-10 w-48" />
        </div>
      </div>

      {/* Right column — Sidebar */}
      <div className="hidden w-96 shrink-0 lg:block">
        <div className="border-gray-light-200 bg-gray-light-50 flex flex-col gap-3 rounded-xl border px-6 py-8">
          <Skeleton className="h-6 w-40" />
          <Skeleton className="h-4 w-56" />
          <Separator />
          <Skeleton className="h-20 w-full" />
          <Separator />
          <Skeleton className="h-6 w-40" />
          <Skeleton className="h-16 w-full" />
        </div>
      </div>
    </div>
  )
}
